export const t = {
  appName: 'JLPT N1 Listening',
  appSubtitle: '問題4 - Tức thì ứng đáp',
  start: 'Bắt đầu',
  replay: 'Nghe lại',
  next: 'Câu tiếp theo →',
  prev: '← Câu trước',
  correct: '✓ Chính xác',
  incorrect: '✗ Sai rồi',
  script: 'Kịch bản',
  question: 'Câu',
  of: '/',
  loading: 'Đang tải...',
  dbLoading: 'Đang tải dữ liệu...',
  noCourses: 'Chưa có khóa học',
  noQuestions: 'Chưa có câu hỏi',
  videoUnavailable: 'Audio không khả dụng. Vui lòng thử lại sau.',
  audioLabel: 'Audio',
  pause: 'Tạm dừng',
  resume: 'Tiếp tục',
  restart: 'Làm lại',
  pickAnswer: 'Chọn đáp án đúng (1, 2 hoặc 3) trong khi nghe',
  testInstructions: 'Hướng dẫn',
  instr1: 'Nghe liền mạch từ đầu đến cuối đề như đi thi thật.',
  instr2: 'Khi mỗi câu phát, bấm nút 1 / 2 / 3 để chọn đáp án.',
  instr3: 'Sau khi nghe xong cả đề, xem kết quả và kịch bản.',
  results: 'Kết quả',
  correctOf: 'câu đúng',
  notAnswered: 'chưa trả lời',
  viewScript: 'Xem kịch bản đầy đủ →',
  hideScript: '↑ Ẩn kịch bản',
  backToCourses: 'Về trang chính',
  examList: 'Danh sách đề thi',
  exam: 'Đề thi',
  year: 'Năm',
  introMessage: 'Câu sắp đến — chờ một lát...',
  narratorIntroMessage: 'Đang nghe hướng dẫn (問題4) — câu 1 sắp đến',
  narratorIntroChipTooltip: 'Phần hướng dẫn (問題4)',
  errorTitle: 'Đã xảy ra lỗi',
  errorRetry: 'Thử lại',
  errorGoHome: 'Về trang chính',
  errorOfflineTitle: 'Mất kết nối Internet',
  errorOfflineDetail: 'Vui lòng kiểm tra mạng (Wi-Fi / 4G) rồi thử lại.',
  errorGenericDetail: 'Vui lòng thử lại sau giây lát.',
  pickAnOption: 'Chọn đáp án đúng',
  audioPlaying: 'Đang phát âm thanh...',
  pressStart: 'Nhấn "Bắt đầu" để nghe câu hỏi',
  startCourse: 'Bắt đầu học',
  questionCount: (n: number) => `${n} câu hỏi`,
  questionShort: (n: number) => `Câu ${n}`,
  reviewNeeded: 'Cần kiểm tra',
  yourAnswer: 'Đáp án của bạn',
  correctAnswer: 'Đáp án đúng',
  optionLabel: (n: number) => `Đáp án ${n}`,
  replayQuestion: '🔁 Nghe lại câu',
  prevQuestion: '⏮ Câu trước',
  nextQuestion: 'Câu sau ⏭',
  skipBack: '⟲ 10s',
  skipForward: '10s ⟳',
  showLiveScript: '📜 Hiện script',
  hideLiveScript: '📜 Ẩn script',
  liveScriptLabel: 'Script (kèm hiện chữ khi nghe)',
  resumeBannerTitle: '📌 Đang dở quiz này',
  resumeBannerMsg: (qNum: number, time: string) => `Bạn đang ở câu ${qNum} (${time}). Tiếp tục từ đó?`,
  resumeContinue: 'Tiếp tục',
  resumeFromStart: 'Làm lại từ đầu',
  keyboardHint: '← →: tua 10s · Space: pause · 1/2/3: chọn',
  yourPick: 'Bạn chọn',
  optionCorrect: '← Đáp án đúng',
  optionUserPick: '← Bạn chọn',
  replayThisQuestion: '▶ Nghe lại đoạn này',
  unanswered: '— Không trả lời',
  questionResultCorrect: '✓ Đúng',
  questionResultWrong: '✗ Sai',
  promptLabel: 'Câu hỏi',
  optionsLabel: 'Lựa chọn',
  expandFullScript: 'Xem script đầy đủ',
  collapseFullScript: 'Ẩn script đầy đủ',

  // Auth
  authSignIn: 'Đăng nhập',
  authSignUp: 'Đăng ký',
  authSignOut: 'Đăng xuất',
  authEmail: 'Email',
  authPassword: 'Mật khẩu',
  authConfirmPassword: 'Nhập lại mật khẩu',
  authDisplayName: 'Tên hiển thị',
  authDisplayNamePlaceholder: 'VD: Bùi Thu',
  authForgot: 'Quên mật khẩu?',
  authSendReset: 'Gửi email khôi phục',
  authResetSent: 'Nếu email tồn tại, link đặt lại mật khẩu đã được gửi.',
  authNoAccount: 'Chưa có tài khoản?',
  authHasAccount: 'Đã có tài khoản?',
  authGoogle: 'Đăng nhập với Google',
  authGoogleSignUp: 'Đăng ký với Google',
  authMismatch: 'Mật khẩu nhập lại không khớp.',
  authProfile: 'Tài khoản',
  authGuest: 'Khách',
  authProgressSyncing: 'Đang đồng bộ tiến độ…',
  authMergeTitle: 'Đồng bộ tiến độ vào tài khoản?',
  authMergeBody: (n: number) =>
    `Bạn có ${n} bài đã làm khi chưa đăng nhập. Đồng bộ lên tài khoản để xem được trên các thiết bị khác?`,
  authMergeYes: 'Đồng bộ',
  authMergeNo: 'Bỏ qua',
  authLoading: 'Đang xử lý…',
  authBackHome: '← Về trang chính',
} as const;
